var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_1642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 12.5H16.25C16.4158 12.5 16.5747 12.4342 16.6919 12.3169C16.8092 12.1997 16.875 12.0408 16.875 11.875V3.75C16.875 3.58424 16.8092 3.42527 16.6919 3.30806C16.5747 3.19085 16.4158 3.125 16.25 3.125H7.5C7.33424 3.125 7.17527 3.19085 7.05806 3.30806C6.94085 3.42527 6.875 3.58424 6.875 3.75V4.375",
    stroke: "#888A93",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 10.625L6.25 12.5L8.125 14.375",
    stroke: "#888A93",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5H3.75C3.58424 7.5 3.42527 7.56585 3.30806 7.68306C3.19085 7.80027 3.125 7.95924 3.125 8.125V16.25C3.125 16.4158 3.19085 16.5747 3.30806 16.6919C3.42527 16.8092 3.58424 16.875 3.75 16.875H12.5C12.6658 16.875 12.8247 16.8092 12.9419 16.6919C13.0592 16.5747 13.125 16.4158 13.125 16.25V15.625",
    stroke: "#888A93",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 9.375L13.75 7.5L11.875 5.625",
    stroke: "#888A93",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_1642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.64f6d54593198c5ea8a12bb4c212c3be.svg";
export { ForwardRef as ReactComponent };